export default __webpack_public_path__ + "static/media/get-hired.7115b95e.svg";